// Libraries
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';

// Dependencies
import Loader from 'components/elements/Loader';
import { EMAIL_VERIFIED } from 'models/User';
import { useGetUserStatusQuery } from 'services/apiSlices/userApi';
import { selectors as userSelectors } from 'store/modules/user';
import { getAuthLinkSearch } from 'utils/signupCampaign';
import { LOGIN, VERIFY_EMAIL } from './paths';

const PrivateRoutes = () => {
  const location = useLocation();
  // TODO: we are already checking this variable outside in src/containers/Routes/index.js, why do we need it here too?
  const isAuthenticated = useSelector(userSelectors.isAuthenticated);
  const {
    data: userStatus,
    isLoading: isLoadingUserStatus,
    isFetching: isFetchingUserStatus,
  } = useGetUserStatusQuery(null, {
    skip: !isAuthenticated,
  });

  if (isAuthenticated && (isLoadingUserStatus || isFetchingUserStatus)) {
    return <Loader />;
  }

  // if user is unauthenticated and their email is not null (legacy) but is false (unverified),
  // redirect to /verify-email to send them the verification email
  if (isAuthenticated && userStatus?.email_verified === EMAIL_VERIFIED.UNVERIFIED) {
    return <Navigate to={VERIFY_EMAIL} />;
  }

  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page (keeping custom link and referral params)
  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to={{ pathname: LOGIN, search: getAuthLinkSearch(location.search) }} />
  );
};

export default PrivateRoutes;

/* DOCS
To be used like:

<Route exact path='/' element={<PrivateRoute />}> // this wrapper Route will protect the children Route's
  <Route exact path='/' element={<Home />} /> // Pure Route's to be rendered already protected by the parent Route
</Route>

*/
